import { Spacings, View } from "react-native-ui-lib";
import { useCartContextProvider } from "../../hooks";
import { CustomerCard } from "../../../CustomerCard";
import { Button, Divider } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface HeaderProps {}

export const Header = ({}: HeaderProps) => {
  const { t } = useTranslation("pos");
  const { items, handleOnClearCart, navigation, sale, handleOnEditCustomer } =
    useCartContextProvider();

  return (
    <>
      <View row style={{ marginBottom: Spacings.s4 }}>
        <View marginR-10 flex>
          <Button
            isDestructive
            label={t("button.empty_cart")}
            onPress={handleOnClearCart}
            fullWidth
            disabled={items.length === 0}
          />
        </View>
        <View flex>
          <Button
            onPress={() =>
              navigation.navigate("ActionsRootScreen", {
                screen: "MoreActionsScreen",
              })
            }
            isAction
            label={t("button.actions")}
            fullWidth
          />
        </View>
      </View>
      {!!sale.customer.id && (
        <View>
          <CustomerCard
            onEditCustomer={handleOnEditCustomer}
            wrapped={false}
            customerId={sale.customer.id}
          />
          <Divider />
        </View>
      )}
    </>
  );
};
